
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pamong/pegawai/perencanaan/rangkuman",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pamong/pegawai/perencanaan/rangkuman/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pamong/pegawai/perencanaan/rangkuman"])
      });
    }
  